import { z } from 'zod';

// Zod schema for revenue category creation form
export const createRevenueCategoryFormSchema = (maxRevenueValue = 100000) =>
  z.object({
    name: z.string().min(1, { message: 'Revenue category name is required' }),
    description: z.string().min(1, { message: 'Description is required' }),
    rcrt: z.preprocess(
      (val) => {
        if (val === '' || val === null || val === undefined) return undefined;
        const num = Number(val);
        return isNaN(num) ? undefined : num;
      },
      z
        .number({ required_error: 'RCRT is required', invalid_type_error: 'RCRT is required' })
        .min(0, { message: 'Must be a positive number' })
        .max(maxRevenueValue, { message: `RCRT cannot exceed €${maxRevenueValue.toLocaleString()}` })
    ),
    rcrt_alert_threshold: z.number().min(0).max(100, {
      message: 'Must be between 0 and 100'
    })
  });

export const revenueCategoryFormSchema = createRevenueCategoryFormSchema();

export type RevenueCategoryFormValues = z.infer<typeof revenueCategoryFormSchema>;

// API interfaces
export interface RevenueCategoryCreationData {
  name: string;
  description?: string;
  rcrt: number;
  rcrt_alert_threshold: number;
}

export interface RevenueCategory {
  _id: string;
  user_id: string;
  budget_id: string;
  is_default: boolean;
  category: string;
  name: string;
  description?: string;
  rcrt: number;
  acmev?: number;
  rc_committed_amount: number;
  rcrt_alert_threshold: number;
  rcrt_achieved: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
